// src/pages/home/Login.jsx
import { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import Navbar from "../../components/Navbar";
import Swal from "sweetalert2";
import { FaSpinner } from "react-icons/fa";

const Login = () => {
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const result = await login(email, password);
      if (result.success) {
        navigate("/"); // Redirect to home on successful login
      } else {
        await Swal.fire({
          icon: "error",
          title: "Login Failed",
          text: result.message || "Invalid credentials. Please try again.",
          confirmButtonColor: '#3B82F6', // Blue-600
        });
      }
    } catch (err) {
      console.error("Login error", err);
      await Swal.fire({
        icon: "error",
        title: "An Error Occurred",
        text: "Something went wrong during login. Please try again later.",
        confirmButtonColor: '#3B82F6',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col">
      <Navbar />
      <div className="flex-grow flex items-center justify-center p-4">
        <div className="w-full max-w-4xl mx-auto bg-white shadow-xl rounded-2xl grid md:grid-cols-2 overflow-hidden">
          
          {/* Left Panel (Branding) */}
          <div className="hidden md:flex flex-col items-center justify-center p-12 bg-blue-600 text-white text-center">
            <img src="/images/parasports.png" alt="Parasports Logo" className="w-24 h-auto mb-6" />
            <h1 className="text-3xl font-bold mb-2">A Decade of Triumph</h1>
            <p className="text-blue-100">Empowering Divyang Athletes, Inspiring Excellence.</p>
          </div>

          {/* Right Panel (Form) */}
          <div className="p-8 sm:p-12">
            <h2 className="text-3xl font-bold text-slate-900 mb-2">Welcome Back!</h2>
            <p className="text-slate-600 mb-8">Sign in to access your account.</p>
            
            <form onSubmit={handleLogin} className="space-y-6">
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-slate-700 mb-1">
                  Email Address
                </label>
                <input
                  id="email"
                  type="email"
                  placeholder="you@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="w-full px-4 py-3 bg-slate-100 border border-slate-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none transition-shadow"
                />
              </div>

              <div>
                <label htmlFor="password" className="block text-sm font-medium text-slate-700 mb-1">
                  Password
                </label>
                <input
                  id="password"
                  type="password"
                  placeholder="••••••••"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className="w-full px-4 py-3 bg-slate-100 border border-slate-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none transition-shadow"
                />
              </div>
              
              <button
                type="submit"
                disabled={loading}
                className="w-full flex justify-center items-center gap-3 bg-blue-600 hover:bg-blue-700 disabled:bg-blue-400 text-white font-bold py-3 px-4 rounded-lg text-lg shadow-md hover:shadow-lg transition-all"
              >
                {loading && <FaSpinner className="animate-spin" />}
                {loading ? "Signing In..." : "Sign In"}
              </button>
            </form>

            <div className="text-center mt-6">
              <p className="text-sm text-slate-600">
                Don't have an account?{" "}
                <Link to="/register" className="font-semibold text-blue-600 hover:text-blue-700 hover:underline">
                  Sign up
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
